// The words under each game.
//
// The four game pages carried 69 to 94 words between them, so a search engine
// had almost nothing to read and they sat on page two for "one piece quiz"
// while the homepage ranked. This adds a short section under the game — what
// the round is, how the scoring works, links to the rest of the site, and a
// few real questions — plus the FAQ in schema so the answers can show in
// search results. It sits below the play area: nobody has to read it to play.

import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ALL_GAMES } from './quizPageText.data';
import { Helmet } from 'react-helmet-async';

// The page's own links first, then any game it left out, never the page itself.
const RestLinks = ({ links }) => {
  const { pathname } = useLocation();
  const all = [...links, ...ALL_GAMES.filter((g) => !links.some((l) => l.to === g.to))]
    .filter((l) => l.to !== pathname);
  if (!all.length) return null;
  return (
    <>
      <h3>Play the rest</h3>
      <ul className="seo-links">
        {all.map((link) => (
          <li key={link.to}>
            <Link to={link.to}>{link.label}</Link> — {link.note}
          </li>
        ))}
      </ul>
    </>
  );
};

const QuizPageText = ({ title, intro, howItWorks, faq = [], links = [] }) => (
  <>
    {faq.length > 0 && (
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faq.map((item) => ({
              '@type': 'Question',
              name: item.q,
              acceptedAnswer: { '@type': 'Answer', text: item.a },
            })),
          })}
        </script>
      </Helmet>
    )}

    <section className="seo-content quiz-page-text">
      <h2>{title}</h2>
      {intro.map((paragraph, i) => (
        <p key={i}>{paragraph}</p>
      ))}

      {howItWorks && howItWorks.length > 0 && (
        <>
          <h3>How a round works</h3>
          <ul className="seo-links">
            {howItWorks.map((line, i) => (
              <li key={i}>{line}</li>
            ))}
          </ul>
        </>
      )}

      {faq.length > 0 && (
        <>
          <h3>Questions players ask</h3>
          {faq.map((item) => (
            <div key={item.q} className="quiz-faq-item">
              <h4>{item.q}</h4>
              <p>{item.a}</p>
            </div>
          ))}
        </>
      )}

      <RestLinks links={links} />
    </section>
  </>
);

export default QuizPageText;
